import { createBrowserRouter, Navigate } from "react-router-dom";
import { AdminRoute } from "./components/AdminRoute";
import { AppShell } from "./components/AppShell";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { useAuth } from "./context/AuthContext";
import { AdminPage } from "./pages/AdminPage";
import { AdminUserFormPage } from "./pages/AdminUserFormPage";
import { AdminTournamentFormPage } from "./pages/AdminTournamentFormPage";
import { AdminTournamentPage } from "./pages/AdminTournamentPage";
import { DashboardPage } from "./pages/DashboardPage";
import { GameDetailPage } from "./pages/GameDetailPage";
import { GameEditPage } from "./pages/GameEditPage";
import { GamesPage } from "./pages/GamesPage";
import { LeaderboardPage } from "./pages/LeaderboardPage";
import { LoginConsumePage } from "./pages/LoginConsumePage";
import { LoginPage } from "./pages/LoginPage";
import { LoginSentPage } from "./pages/LoginSentPage";
import { NewGamePage } from "./pages/NewGamePage";
import { NewHandPage } from "./pages/NewHandPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ProfilePage } from "./pages/ProfilePage";
import { TournamentDetailPage } from "./pages/TournamentDetailPage";
import { TournamentTeamPage } from "./pages/TournamentTeamPage";
import { TournamentsPage } from "./pages/TournamentsPage";

function HomeRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  return <Navigate to={user ? "/home" : "/login"} replace />;
}

export const router = createBrowserRouter([
  { path: "/", element: <HomeRedirect /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/login/sent", element: <LoginSentPage /> },
  { path: "/login/consume", element: <LoginConsumePage /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: "/home", element: <DashboardPage /> },
          { path: "/profile", element: <ProfilePage /> },
          { path: "/games", element: <GamesPage /> },
          { path: "/games/new", element: <NewGamePage /> },
          { path: "/games/:gameId", element: <GameDetailPage /> },
          { path: "/games/:gameId/edit", element: <GameEditPage /> },
          { path: "/games/:gameId/hands/new", element: <NewHandPage /> },
          {
            path: "/games/:gameId/hands/:handId",
            element: <NewHandPage />,
          },
          {
            path: "/games/:gameId/hands/:handId/edit",
            element: <NewHandPage />,
          },
          { path: "/tournaments", element: <TournamentsPage /> },
          {
            path: "/tournaments/:tournamentId",
            element: <TournamentDetailPage />,
          },
          {
            path: "/tournaments/:tournamentId/team",
            element: <TournamentTeamPage />,
          },
          { path: "/leaderboard", element: <LeaderboardPage /> },
          {
            path: "/rules",
            lazy: async () => {
              const { RulesPage } = await import("./pages/RulesPage");
              return { Component: RulesPage };
            },
          },
          {
            element: <AdminRoute />,
            children: [
              { path: "/admin", element: <AdminPage /> },
              { path: "/admin/users/new", element: <AdminUserFormPage /> },
              {
                path: "/admin/tournaments/new",
                element: <AdminTournamentFormPage />,
              },
              {
                path: "/admin/tournaments/:tournamentId",
                element: <AdminTournamentPage />,
              },
              {
                path: "/admin/tournaments/:tournamentId/edit",
                element: <AdminTournamentFormPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);
